import { html as o, when as m } from "@microsoft/fast-element";
import { arrowHeadDownTemplate as t } from "./arrow-head-down.js";
import { arrowHeadLeftTemplate as a } from "./arrow-head-left.js";
import { arrowHeadRightTemplate as r } from "./arrow-head-right.js";
import { arrowHeadUpTemplate as p } from "./arrow-head-up.js";
import { barsSortTemplate as l } from "./bars-sort.js";
import { pinTemplate as n } from "./pin.js";
import { homeStackedTemplate as i } from "./home-stacked.js";
import { actionHubTemplate as f } from "./action-hub.js";
import { bentoTemplate as c } from "./bento.js";
import { contractTemplate as d } from "./contract.js";
import { dockBottomTemplate as T } from "./dock-bottom.js";
import { dockFloatTemplate as $ } from "./dock-float.js";
import { dockLeftTemplate as h } from "./dock-left.js";
import { dockRightTemplate as s } from "./dock-right.js";
import { dockTopTemplate as k } from "./dock-top.js";
import { documentCheckOnHold as u } from "./document-check-on-hold.js";
import { dotTemplate as w } from "./dot.js";
import { egosecureTemplate as v } from "./egosecure.js";
import { uemTemplate as b } from "./uem.js";
import { suemTemplate as g } from "./suem.js";
import { masterDataTemplate as H } from "./master-data.js";
import { level0Template as D } from "./level-0.js";
import { level1Template as L } from "./level-1.js";
import { level2Template as R } from "./level-2.js";
import { level3Template as S } from "./level-3.js";
import { licenseTemplate as x } from "./license.js";
import { headsetTemplate as B } from "./headset.js";
const ae = o`
  ${m((e) => e.name === "action-hub", f)}
  ${m((e) => e.name === "arrow-head-down", t)}
  ${m((e) => e.name === "arrow-head-left", a)}
  ${m((e) => e.name === "arrow-head-right", r)}
  ${m((e) => e.name === "arrow-head-up", p)}
  ${m((e) => e.name === "bars-sort", l)}
  ${m((e) => e.name === "bento", c)}
  ${m((e) => e.name === "contract", d)}
  ${m((e) => e.name === "dock-bottom", T)}
  ${m((e) => e.name === "dock-float", $)}
  ${m((e) => e.name === "dock-left", h)}
  ${m((e) => e.name === "dock-right", s)}
  ${m((e) => e.name === "dock-top", k)}
  ${m((e) => e.name === "document-check-on-hold", u)}
  ${m((e) => e.name === "dot", w)}
  ${m((e) => e.name === "egosecure", v)}
  ${m((e) => e.name === "headset", B)}
  ${m((e) => e.name === "home-stacked", i)}
  ${m((e) => e.name === "level-0", D)}
  ${m((e) => e.name === "level-1", L)}
  ${m((e) => e.name === "level-2", R)}
  ${m((e) => e.name === "level-3", S)}
  ${m((e) => e.name === "license", x)}
  ${m((e) => e.name === "master-data", H)}
  ${m((e) => e.name === "pin", n)}
  ${m((e) => e.name === "suem", g)}
  ${m((e) => e.name === "uem", b)}
`;
export {
  ae as customIconTemplate
};
